import React from 'react';
import Table from '../../app-components/table/Table';
import {Text} from '../../app-components';
import {removeData} from '../../AppServices';
import {listUri} from '../../Queries';
import {colors} from '../../theme/colors';
import {h12_Regular, h14_Medium} from '../../theme/fonts';
import {serialNumber} from '../RPM/rpmUtils';
const {backdropColor70} = colors;
let uri = () => {
  return listUri({
    model: 'TodoCategory',
    id: 'todoCategoryList',
  });
};

const tableData = {
  lg: {
    columns: [
      {
        width: 50,
      },
      {
        render: serialNumber,
        header: 'S.No.',
        width: 150,
      },
      {
        type: 'text',
        field: 'name',
        header: 'To-Do Task Category',
      },
    ],
    hoverActions: [
      {
        value: 'Edit',
        align: 'right',
        textStyle: {
          color: '#9a9a9a',
          fontWeight: 500,
          ...h14_Medium,
        },
        action: ({item}) => {
          return {
            type: 'link',
            link: {
              view: 'edit-todo-category',
              params: {item},
            },
          };
        },
      },
      {
        value: 'Delete',
        position: 'center',
        align: 'right',
        textStyle: {
          color: 'rgb(241,79,79, 0.87)',
          fontWeight: 500,
          ...h14_Medium,
        },
        action: {
          type: 'link',
          link: (props) => {
            let {item} = props;
            return {
              view: 'delete-masterData',
              modal: true,
              params: {
                item,
                label: 'Todo',
                deleteAction: () => removeData({item, model: 'Todo'}),
                reloadEvent: 'reloadTodoCategory',
              },
              modalProps: {
                autoHide: true,
                height: 250,
                backdropColor: backdropColor70,
              },
            };
          },
        },
      },
    ],
  },
  sm: {
    columns: [
      {
        width: 50,
      },
      {
        render: serialNumber,
        header: 'S.No.',
        width: 150,
      },
      {
        type: 'text',
        field: 'name',
        header: 'To-Do Task Category',
        width: 300,
      },
    ],
  },
};

export default Table({
  uri,
  ...tableData,
  reloadEvent: 'reloadTodoCategory',
});
